import { Link } from "react-router-dom";
import { processSteps } from "@/mocks/clueData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function SubmitProcess() {
  return (
    <section className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-5">
          <SectionHeading
            eyebrow="投稿指南"
            icon="ri-route-line"
            title="从线索到发布，只走四步"
            desc="我们不追求“最快”，而是尽量让每一条线索都经得起阅读。下面是投稿之后会发生的事。"
          />
          <div className="mt-8 rounded-lg border border-secondary-200 bg-secondary-50 p-6">
            <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
              <i className="ri-lock-2-line text-lg text-secondary-700"></i>
              隐私我们放在第一位
            </h3>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              匿名投稿不会展示你的姓名与联系方式；实名投稿也会先征得同意，再决定公开哪些信息。
              请在正文中避免填写他人的隐私内容。
            </p>
            <Link
              to="/submit"
              className="mt-5 inline-flex whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
            >
              阅读投稿须知
            </Link>
          </div>
        </div>

        <ol className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7">
          {processSteps.map((step, index) => (
            <li
              key={step.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  0{index + 1}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}